import React, { useEffect, useState, useCallback } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { setPortal } from 'modules/portal';
import { showSuccessSnackbar } from 'modules/snackbar';
import { getCategory } from 'lib/api/common';

import MainTemplate from 'pages/templates/MainTemplate';

import CurrentStatus from 'components/atoms/CurrentStatus';
import MbTabs from 'components/organisms/MbTabs';

import Statistics from './Statistics';
import DetailModal from './DetailModal';

const Budget = () => {
  let { path } = useRouteMatch();
  const dispatch = useDispatch();
  const productList = ['BANNER', 'ICOVER', 'NATIVE'];

  const { menu, portal } = useSelector(({ menu, portal }) => ({
    menu: menu.list === null ? new Map() : menu.list,
    portal: portal,
  }));

  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCategory({ userTpCode: '01' })
      .then((response) => {
        const { data } = response.data;
        let categoryList = [];
        for (let category of data) {
          categoryList.push({
            label: category['CTGR_NM'],
            value: category['CTGR_SEQ'],
          });
        }
        setCategoryList(categoryList);
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      })
      .finally(() => {
        setLoading(false);
      });
    // eslint-disable-next-line
  }, []);

  let devLocation;
  if (window.origin === 'https://admfe4.mobon.net') {
    devLocation = 'https://mac4.mobon.net';
  } else {
    devLocation = 'https://adcenter.mobon.net';
  }

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  const tabList = () => {
    for (let curMenu of menu.values()) {
      if (typeof curMenu.subMenu !== 'undefined') {
        const cur = curMenu.subMenu.get(path);
        if (typeof cur !== 'undefined') {
          // 현재 2dapth url에 매칭되는 것이 있으면 그 메뉴의 하위 tab 반환
          return cur.subMenu;
        }
      }
    }
  };

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <MainTemplate>
      {loading ? (
        <CurrentStatus type="loading" option="useMinHeight" />
      ) : (
        <MbTabs
          name="Budget"
          tabMenuList={tabList()}
          tabs={{
            '/report/budget/category': {
              tabComponent: (
                <Statistics
                  devLocation={devLocation}
                  handlePortalUrl={handlePortalUrl}
                  productList={productList}
                  categoryList={categoryList}
                  handleClickSnackbar={handleClickSnackbar}
                />
              ),
            },
            '/report/budget/share/detail': {
              tabComponent: (
                <DetailModal
                  devLocation={devLocation}
                  handlePortalUrl={handlePortalUrl}
                  productList={productList}
                  categoryList={categoryList}
                  handleClickSnackbar={handleClickSnackbar}
                />
              ),
              isPop: 1,
            },
          }}
        />
      )}
    </MainTemplate>
  );
};

export default Budget;
